import $ from 'jquery'

export const init = async function () {
  $('.AnimatedCategories-item').hover(
    function () {
      $('.AnimatedCategories-item').removeClass('active')
      $(this).addClass('active')
    },
    function () {
      $('.AnimatedCategories-item').removeClass('active')
      $('.AnimatedCategories-item:nth-child(2)').addClass('active')
    }
  )
}
